// extracted by mini-css-extract-plugin
export default {"DeleteButton":"DeleteShortUrlModal_DeleteButton__b2dLA","DeleteShortUrlModal":"DeleteShortUrlModal_DeleteShortUrlModal__w-+o1"};